// Lightweight global event-based notification system.
// Components subscribe via subscribe(); the Toast component listens.

let listeners = [];
let nextId = 1;

export const subscribeNotify = (cb) => {
  listeners.push(cb);
  return () => {
    listeners = listeners.filter((l) => l !== cb);
  };
};

const emit = (toast) => {
  listeners.forEach((cb) => cb(toast));
};

const push = (type, message, duration = 4500) => {
  const id = nextId++;
  emit({ id, type, message, duration });
  return id;
};

export const notify = {
  success: (msg, duration) => push('success', msg, duration),
  error: (msg, duration) => push('error', msg, duration || 6000),
  info: (msg, duration) => push('info', msg, duration),
  warning: (msg, duration) => push('warning', msg, duration),
  loading: (msg) => push('loading', msg, 0)
};

export const removeNotify = (id) => {
  emit({ id, remove: true });
};
